import {BaseVictoryPointData} from './BaseVictoryPointData.ts'
import {VictoryPointType} from '@colonist/game-states'

/**
 * @deprecated use `packages/game-states`'s VictoryPointType instead
 */
export import VictoryPointTypes = VictoryPointType

export class VictoryPointDataSettlement extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Settlement
    value = 1
    private = false
}

export class VictoryPointDataCity extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.City
    value = 2
    private = false
}

export class VictoryPointDataDevelopmentCard extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.DevelopmentCardVictoryPoint
    value = 1
    private = true
}

export class VictoryPointDataLargestArmy extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.LargestArmy
    value = 2
    private = false
}

export class VictoryPointDataLongestRoad extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.LongestRoad
    value = 2
    private = false
}

export class VictoryPointDataChit extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Chits
    value = 1
    private = false
}

export class VictoryPointDataMetropolis extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Metropolis
    value = 2
    private = false
}

export class VictoryPointDataDefenderOfColonist extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.DefenderOfColonist
    value = 1
    private = false
}

export class VictoryPointDataProgressCard extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.ProgressCardVictoryPoint
    value = 1
    private = false
}

export class VictoryPointDataMerchant extends BaseVictoryPointData {
    victoryPointType = VictoryPointTypes.Merchant
    value = 1
    private = false
}
